<div class="container">
  <div class="row immigration">
    <div class="col">
      <eos-employee-file-upload [isAdditionalUpload]="true" [employeeProfile]="model" 
                                (GetDocumentEvent)="GetDocuments($event)" (validDocuments)="setValidDocuments($event)" [readonly]="!canSubmit" >
      </eos-employee-file-upload>
    </div>

  </div>
  <div class="row immigration">
    <div class="col-12 mt-4 text-center">
      <button eosDebounce class="btn btn-secondary me-2" *ngIf='canSubmit' (debounceClick)="submit()"
              type="submit">
        Submit
      </button>
    </div>
  </div>
</div>
